import React from "react";
import PropTypes from "prop-types";
import { useRouteMatch } from "react-router-dom";

import { useCurrentUserContext } from "contexts/CurrentUserContext";

import { SiteHeader } from "core/SiteHeader";
import { LoginLink, JoinLink } from "core/SiteHeader/HeaderLoggedOutLinks";
import LoadingSpinner from "core/LoadingSpinner";

import { LoadingContainer } from "core/SiteHeader/styles";
import { PHOTO_CHECKOUT, ICON_CHECKOUT } from "data/links";

import logOutAndRedirect from "helpers/log-out";

const SiteHeaderParent = ({
    transparent,
    heroSearchBgColor,
    isHeroSearchV2
}) => {
    const onPhotoCheckoutPage = useRouteMatch(PHOTO_CHECKOUT);
    const onIconCheckoutPage = useRouteMatch(ICON_CHECKOUT);

    const {
        currentUser: { loading, data }
    } = useCurrentUserContext();

    if (onPhotoCheckoutPage || onIconCheckoutPage) return null;

    if (loading) {
        return (
            <LoadingContainer heroSearchBgColor={heroSearchBgColor}>
                <LoadingSpinner />
            </LoadingContainer>
        );
    }

    const { currentUser } = data;

    const handleLogOut = () => {
        logOutAndRedirect();
    };

    return (
        <SiteHeader
            isHeroSearchV2={isHeroSearchV2}
            heroSearchBgColor={heroSearchBgColor}
            currentUser={currentUser}
            transparent={transparent}
            loginLink={<LoginLink isHeroSearchV2={isHeroSearchV2} />}
            joinLink={<JoinLink isHeroSearchV2={isHeroSearchV2} />}
            handleLogOut={handleLogOut}
        />
    );
};

SiteHeaderParent.propTypes = {
    heroSearchBgColor: PropTypes.string,
    isHeroSearchV2: PropTypes.bool,
    // used to indicate if we want the header to be transparent
    transparent: PropTypes.bool
};

export default SiteHeaderParent;
